import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExtendedTypography } from "@vapor/react-extended/ExtendedTypography/ExtendedTypography";
import { Stack } from "@vapor/react-material";
import React from "react";

interface WorkspaceDetailsSectionTitleProps {
    icon?: any;
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    rightItems?: React.ReactNode;
}

const WorkspaceDetailsSectionTitle = ({ icon, title, rightItems, subtitle }: WorkspaceDetailsSectionTitleProps) => {
    return (
        <Stack spacing={1}>
            {
                <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                    <ExtendedTypography color={"primary.textTitleColor"} variant={"titleMedium"}>
                        {icon && <FontAwesomeIcon icon={icon} style={{ marginRight: 8 }} />}
                        {title}
                    </ExtendedTypography>
                    {rightItems ? rightItems : null}
                </Stack>
            }
            {subtitle && (
                <ExtendedTypography color={"primary.textSubduedColor"} variant={"bodyLarge"}>
                    {subtitle}
                </ExtendedTypography>
            )}
        </Stack>
    );
};

export default WorkspaceDetailsSectionTitle;
